import { isAxiosError } from "axios";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export { formatPrice, parsePrice } from "@client-shared/utils/format";

export const getApiErrorCode = (error: unknown): string | undefined => {
  if (!isAxiosError(error)) return undefined;
  const data = error.response?.data as Record<string, unknown> | undefined;
  return (data?.["errorCode"] as string) || undefined;
};

export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  if (isAxiosError(error)) {
    const data = error.response?.data as Record<string, unknown> | undefined;
    return (data?.["detail"] as string) || (data?.["message"] as string) || fallback;
  }
  return fallback;
};
